import { AssetManagementRepository } from '../data/asset-management-repository';
import { AssetUploadFormData, UploadAssetResponse } from '../types/asset-types';

/**
 * Use case for uploading a new asset or new version
 * Note: operatorId is automatically injected by the API layer from user context
 * if not provided (for regular operators), or uses the provided value (for distributors)
 */
export class UploadAssetUseCase {
  constructor(private readonly repository: AssetManagementRepository) {}

  async execute(request: AssetUploadFormData): Promise<UploadAssetResponse> {
    return this.repository.uploadAsset(request);
  }
}
